import { STRING } from '@/plugins/sdk/fields'
import isString from 'lodash/isString'

export default {
  label: 'Does not begin with',
  operator: 'does not begin with',
  fields: [ STRING ],
  isValidValue (value) {
    return isString(value) && value.length
  }
}
